import React from 'react';
import { useTranslation } from '../i18n/i18n';

function Home() {
  const { t } = useTranslation();
  return (
    <div>
      <h1>{t('dashboard_title')}</h1>
    </div>
  );
}

export default Home;
